var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalGasStationBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AAC3F603-E45D-43D8-916A-A3CB5114D97F@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCC6-Make-a-reservation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-reservations-card_Park-Place",
    transform: "translate(-911.000000, -349.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local_gas_station_black_24dp-copy",
    transform: "translate(911.000000, 349.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.18,4.82 L13.1866667,4.81333333 L11.06,2.68666667 C10.8666667,2.49333333 10.5466667,2.49333333 10.3533333,2.68666667 C10.16,2.88 10.16,3.2 10.3533333,3.39333333 L11.4066667,4.44666667 C10.7066667,4.71333333 10.2333333,5.42666667 10.3533333,6.25333333 C10.46,6.98666667 11.0866667,7.58 11.82,7.66 C12.1333333,7.69333333 12.4066667,7.64 12.6666667,7.52666667 L12.6666667,12.3333333 C12.6666667,12.7 12.3666667,13 12,13 C11.6333333,13 11.3333333,12.7 11.3333333,12.3333333 L11.3333333,9.33333333 C11.3333333,8.6 10.7333333,8 10,8 L9.33333333,8 L9.33333333,3.33333333 C9.33333333,2.6 8.73333333,2 8,2 L4,2 C3.26666667,2 2.66666667,2.6 2.66666667,3.33333333 L2.66666667,13.3333333 C2.66666667,13.7 2.96666667,14 3.33333333,14 L8.66666667,14 C9.03333333,14 9.33333333,13.7 9.33333333,13.3333333 L9.33333333,9 L10.3333333,9 L10.3333333,12.24 C10.3333333,13.1133333 10.96,13.9066667 11.8266667,13.9933333 C12.8266667,14.0933333 13.6666667,13.3133333 13.6666667,12.3333333 L13.6666667,6 C13.6666667,5.54 13.48,5.12 13.18,4.82 Z M8,6.66666667 L4,6.66666667 L4,4 C4,3.63333333 4.3,3.33333333 4.66666667,3.33333333 L7.33333333,3.33333333 C7.7,3.33333333 8,3.63333333 8,4 L8,6.66666667 Z M12,6.66666667 C11.6333333,6.66666667 11.3333333,6.36666667 11.3333333,6 C11.3333333,5.63333333 11.6333333,5.33333333 12,5.33333333 C12.3666667,5.33333333 12.6666667,5.63333333 12.6666667,6 C12.6666667,6.36666667 12.3666667,6.66666667 12,6.66666667 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalGasStationBlack24Dp);
export default __webpack_public_path__ + "static/media/local_gas_station_black_24dp.a449c6199931a7f4475509d36099caf0.svg";
export { ForwardRef as ReactComponent };